<div class="reports-container">
  <div class="reports-header">
    <h1>Dashboard de Formularios</h1>
  </div>

  <!-- KPI Cards -->
  <div class="kpi-row" *ngIf="Overview">
    <div class="kpi-card">
      <div class="kpi-icon" style="background:#e8f4fd;color:#20a8e1;">
        <i class="fa-solid fa-file-lines"></i>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{ Overview.totalActiveTemplates }}</span>
        <span class="kpi-label">Formularios activos</span>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon" style="background:#f0fdf4;color:#22c55e;">
        <i class="fa-solid fa-paper-plane"></i>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{ Overview.totalSubmissions }}</span>
        <span class="kpi-label">Total submissions</span>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon" style="background:#fef3c7;color:#f59e0b;">
        <i class="fa-solid fa-clock"></i>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{ Overview.recentSubmissions }}</span>
        <span class="kpi-label">Ultimos 30 dias</span>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon" style="background:#f3e8ff;color:#7c3aed;">
        <i class="fa-solid fa-users"></i>
      </div>
      <div class="kpi-body">
        <span class="kpi-value">{{ Overview.topUsers?.length || 0 }}</span>
        <span class="kpi-label">Usuarios activos</span>
      </div>
    </div>
  </div>

  <!-- Charts Row -->
  <div class="charts-row" *ngIf="Overview">
    <div class="chart-card">
      <h3>Tendencia de submissions (30 dias)</h3>
      <div class="chart-container">
        <p-chart *ngIf="TrendChartData" type="line" [data]="TrendChartData" [options]="TrendChartOptions"></p-chart>
        <div *ngIf="!TrendChartData" class="chart-empty">Sin datos de tendencia</div>
      </div>
    </div>
    <div class="chart-card">
      <h3>Formularios mas usados</h3>
      <div class="chart-container">
        <p-chart *ngIf="TopTemplatesChartData" type="doughnut" [data]="TopTemplatesChartData" [options]="TopTemplatesChartOptions"></p-chart>
        <div *ngIf="!TopTemplatesChartData" class="chart-empty">Sin datos</div>
      </div>
    </div>
  </div>

  <!-- Top Lists -->
  <div class="lists-row" *ngIf="Overview">
    <div class="list-card">
      <h3>Top formularios</h3>
      <div *ngFor="let t of Overview.topTemplates; let i = index" class="list-item">
        <span class="list-rank">{{ i + 1 }}</span>
        <span class="list-name">{{ t.Name }}</span>
        <span class="list-count">{{ t.Total }}</span>
      </div>
      <div *ngIf="!Overview.topTemplates?.length" class="list-empty">Sin datos</div>
    </div>
    <div class="list-card">
      <h3>Top usuarios</h3>
      <div *ngFor="let u of Overview.topUsers; let i = index" class="list-item">
        <span class="list-rank">{{ i + 1 }}</span>
        <span class="list-name">{{ u.Name }}</span>
        <span class="list-count">{{ u.Total }}</span>
      </div>
      <div *ngIf="!Overview.topUsers?.length" class="list-empty">Sin datos</div>
    </div>
  </div>

  <!-- Divider -->
  <div class="section-divider">
    <h2>Analisis por formulario</h2>
    <p-select [options]="Templates" optionLabel="Name"
      [(ngModel)]="SelectedTemplate" (onChange)="OnTemplateSelect($event)"
      placeholder="Seleccione un formulario para analizar" [showClear]="true"
      styleClass="template-selector" appendTo="body">
    </p-select>
  </div>

  <!-- Loading -->
  <div *ngIf="IsLoadingStats" class="loading-stats">
    <div class="spinner"></div>
    <p>Cargando estadisticas...</p>
  </div>

  <!-- Field Statistics -->
  <div class="field-stats" *ngIf="FieldStats.length > 0 && !IsLoadingStats">
    <div *ngFor="let field of FieldStats" class="stat-card"
      [class.stat-section]="field.fieldType === 'section'">

      <!-- Section separator -->
      <ng-container *ngIf="field.fieldType === 'section'">
        <h3 class="stat-section-title">{{ field.label }}</h3>
      </ng-container>

      <!-- Field stats -->
      <ng-container *ngIf="field.fieldType !== 'section' && field.stats">
        <div class="stat-header">
          <div class="stat-icon"><i [class]="GetFieldIcon(field.fieldType)"></i></div>
          <div class="stat-title">
            <span class="stat-label">{{ field.label }}</span>
            <span class="stat-type">{{ GetFieldTypeLabel(field.fieldType) }}</span>
          </div>
          <span class="stat-total">{{ field.stats.totalResponses || field.stats.totalSubmissions || field.stats.filledCount || 0 }} respuestas</span>
        </div>

        <div class="stat-body">
          <!-- Number stats -->
          <div *ngIf="field.fieldType === 'number'" class="stat-numbers">
            <div class="stat-num-item">
              <span class="stat-num-value">{{ field.stats.min | number:'1.0-2' }}</span>
              <span class="stat-num-label">Minimo</span>
            </div>
            <div class="stat-num-item">
              <span class="stat-num-value">{{ field.stats.avg | number:'1.0-2' }}</span>
              <span class="stat-num-label">Promedio</span>
            </div>
            <div class="stat-num-item">
              <span class="stat-num-value">{{ field.stats.max | number:'1.0-2' }}</span>
              <span class="stat-num-label">Maximo</span>
            </div>
          </div>

          <!-- Boolean stats -->
          <div *ngIf="field.fieldType === 'boolean'" class="stat-boolean">
            <div class="stat-bool-bar">
              <div class="stat-bool-yes" [style.width.%]="field.stats.yesPercent">
                Si {{ field.stats.yesPercent }}%
              </div>
            </div>
            <div class="stat-bool-counts">
              <span>Si: {{ field.stats.yesCount }}</span>
              <span>No: {{ field.stats.noCount }}</span>
            </div>
          </div>

          <!-- Text long stats -->
          <div *ngIf="field.fieldType === 'text_long'" class="stat-textlong">
            <div class="stat-numbers">
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.filledPercent }}%</span>
                <span class="stat-num-label">Completado</span>
              </div>
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.filledCount }}</span>
                <span class="stat-num-label">Con texto</span>
              </div>
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.emptyCount }}</span>
                <span class="stat-num-label">Vacios</span>
              </div>
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.avgLength }}</span>
                <span class="stat-num-label">Largo promedio</span>
              </div>
            </div>
          </div>

          <!-- Multi select stats -->
          <div *ngIf="field.fieldType === 'multi_select' && field.stats.optionDistribution?.length" class="stat-multiselect">
            <div *ngFor="let opt of field.stats.optionDistribution" class="stat-date-row">
              <span class="stat-date-text">{{ opt.option }}</span>
              <div class="stat-date-bar-wrap">
                <div class="stat-date-bar" [style.width.%]="(opt.count / field.stats.totalResponses) * 100" style="background:#7c3aed;"></div>
              </div>
              <span class="stat-date-count" style="color:#7c3aed;">{{ opt.count }}</span>
            </div>
          </div>

          <!-- Date stats -->
          <div *ngIf="field.fieldType === 'date'" class="stat-date">
            <div class="stat-date-range" *ngIf="field.stats.earliest">
              <div class="stat-date-item">
                <span class="stat-date-label">Mas antigua</span>
                <span class="stat-date-value">{{ field.stats.earliest }}</span>
              </div>
              <div class="stat-date-arrow"><i class="fa-solid fa-arrow-right"></i></div>
              <div class="stat-date-item">
                <span class="stat-date-label">Mas reciente</span>
                <span class="stat-date-value">{{ field.stats.latest }}</span>
              </div>
            </div>
            <div class="stat-date-dist" *ngIf="field.stats.dateDistribution?.length">
              <div *ngFor="let dd of field.stats.dateDistribution" class="stat-date-row">
                <span class="stat-date-text">{{ dd.date }}</span>
                <div class="stat-date-bar-wrap">
                  <div class="stat-date-bar" [style.width.%]="(dd.count / field.stats.totalResponses) * 100"></div>
                </div>
                <span class="stat-date-count">{{ dd.count }}</span>
              </div>
            </div>
          </div>

          <!-- Chart for select/text_short/boolean -->
          <div *ngIf="field.chartData" class="stat-chart">
            <p-chart [type]="field.chartType" [data]="field.chartData" [options]="field.chartOptions" height="200px"></p-chart>
          </div>

          <!-- Top values list for text_short only -->
          <div *ngIf="!field.chartData && field.stats.values?.length > 0 && (field.fieldType === 'text_short')" class="stat-values">
            <div *ngFor="let v of field.stats.values" class="stat-value-row">
              <span class="stat-value-text">{{ v.Value }}</span>
              <span class="stat-value-count">{{ v.Count }}</span>
            </div>
          </div>

          <!-- Table: per-column analysis -->
          <div *ngIf="field.fieldType === 'table' && field.stats.columnStats" class="stat-table">
            <div class="stat-table-summary">
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.totalSubmissions }}</span>
                <span class="stat-num-label">Submissions</span>
              </div>
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.totalRows }}</span>
                <span class="stat-num-label">Filas totales</span>
              </div>
              <div class="stat-num-item">
                <span class="stat-num-value">{{ field.stats.avgRowsPerSubmission }}</span>
                <span class="stat-num-label">Filas/submission</span>
              </div>
            </div>
            <div class="stat-table-columns">
              <div *ngFor="let col of field.stats.columnStats" class="stat-table-col">
                <div class="stat-col-header">
                  <span class="stat-col-name">{{ col.name }}</span>
                  <span class="stat-col-type">{{ col.type }}</span>
                </div>
                <!-- Boolean column: compliance bar -->
                <div *ngIf="col.type === 'boolean'" class="stat-col-bool">
                  <div class="stat-bool-bar">
                    <div class="stat-bool-yes" [style.width.%]="col.truePercent">
                      {{ col.truePercent }}%
                    </div>
                  </div>
                  <span class="stat-col-detail">{{ col.trueCount }} si / {{ col.falseCount }} no</span>
                </div>
                <!-- Number column: min/avg/max -->
                <div *ngIf="col.type === 'number'" class="stat-col-nums">
                  <span>Min: {{ col.min }}</span>
                  <span>Prom: {{ col.avg }}</span>
                  <span>Max: {{ col.max }}</span>
                </div>
                <!-- Text column: top values -->
                <div *ngIf="col.type === 'text_short' || col.type === 'select'" class="stat-col-text">
                  <span *ngFor="let tv of col.topValues" class="stat-col-tag">{{ tv.value }} ({{ tv.count }})</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Signature/image/file: show filled vs empty -->
          <div *ngIf="field.fieldType === 'signature' || field.fieldType === 'image' || field.fieldType === 'file'" class="stat-filled">
            <div class="stat-filled-bar">
              <div class="stat-filled-yes" [style.width.%]="field.stats.filledPercent || 0">
                {{ field.stats.filledPercent || 0 }}% completado
              </div>
            </div>
            <div class="stat-filled-counts">
              <span>Con datos: {{ field.stats.filledCount || 0 }}</span>
              <span>Sin datos: {{ field.stats.emptyCount || 0 }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
